import { Wrapper, useFieldExtension } from "@hygraph/app-sdk-react";
import { useEffect, useRef, useState } from "react";
import "ckeditor4";
import "ckeditor4/lang/en";

const editorConfig = {
  versionCheck: false,
  language: "en",
  defaultLanguage: "en",
  contentsLanguage: "en",
  contentsLangDirection: "ltr",
};

function CKEditor({ name, config, initData, onChange }) {
  const textareaRef = useRef(null);
  const editorRef = useRef(null);
  const onChangeRef = useRef(onChange);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(() => {
    const textarea = textareaRef.current;
    const ckeditor = window.CKEDITOR;

    if (!textarea || !ckeditor) {
      return undefined;
    }

    const existingEditor = ckeditor.instances?.[name];

    if (existingEditor) {
      existingEditor.destroy();
    }

    const editor = ckeditor.replace(textarea, config);
    editorRef.current = editor;

    const handleChange = (event) => onChangeRef.current?.(event);
    editor.on("change", handleChange);

    return () => {
      editor.removeListener("change", handleChange);
      if (editor.status !== "destroyed") {
        editor.destroy();
      }
      editorRef.current = null;
    };
  }, [config, name]);

  return <textarea ref={textareaRef} name={name} defaultValue={initData ?? ""} />;
}

const RichTextEditor = () => {
  const { value, onChange } = useFieldExtension();
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    if (localValue !== value) {
      onChange(localValue);
    }
  }, [localValue, onChange, value]);

  return (
    <>
      <CKEditor
        name="hygraphCKEditor"
        config={editorConfig}
        initData={localValue}
        onChange={(e) => setLocalValue(e.editor.getData())}
      />
    </>
  );
};

const RichTextField = () => (
  <Wrapper>
    <RichTextEditor />
  </Wrapper>
);

export default RichTextField;
